import {
  AccessControlService,
  type AgentAccessOverviewItemDto,
  type SetAgentAccessDto,
} from '@inference.engine/api-client/web';
import type { WorkspaceResponseDto } from '@monksflow/platform-api-sdk';
import { z } from 'zod';
import { inferenceHttp } from '@/lib/api/inference-client';
import { PlatformApi } from '@/lib/api/platform/platformSdk';

// Mirrors the platform SDK's WorkspaceResponseDto. Loose so a field the
// platform adds survives untouched instead of being stripped on the way
// through.
const workspaceListSchema = z.object({
  data: z.array(
    z.looseObject({
      id: z.string(),
      organizationId: z.string(),
      name: z.string(),
      description: z.string().nullable(),
      slug: z.string(),
      logoUrl: z.string().nullable(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  ),
});

export const getAllOrgWorkspaces = async (): Promise<WorkspaceResponseDto[]> => {
  const response = await PlatformApi.platformApi.get<unknown>('/workspaces');
  return workspaceListSchema.parse(response.data).data;
};

export const getAccessOverview = async (
  organizationId: string,
): Promise<AgentAccessOverviewItemDto[]> => {
  const response = await AccessControlService.getAgentsAvailableTo({
    client: inferenceHttp,
    throwOnError: true,
    query: {
      organizationId,
    },
  });
  return response.data;
};

export const setToolAccess = async (
  agentId: string,
  organizationId: string,
  mode: SetAgentAccessDto['mode'],
  workspaceIds: string[],
): Promise<void> => {
  await AccessControlService.setAgentAccess({
    client: inferenceHttp,
    throwOnError: true,
    body: {
      agentId,
      organizationId,
      mode,
      workspaceIds,
    },
  });
};

export const resetToolAccess = async (agentId: string, organizationId: string): Promise<void> => {
  await AccessControlService.resetAgentAccess({
    client: inferenceHttp,
    throwOnError: true,
    path: {
      agentId,
    },
    query: {
      organizationId,
    },
  });
};
